var map = {
	"./Bit.png": "1757",
	"./Biznet.png": "40ae",
	"./CBN Premier.png": "bb1c",
	"./CBN.png": "b027",
	"./D~Net.png": "19c4",
	"./FiberStar.png": "152d",
	"./First Media (POP).png": "d26d",
	"./Hypernet-1.png": "85a2",
	"./Hypernet.png": "2f1c",
	"./ICON+-old.png": "5c85",
	"./ICON+.png": "be9f",
	"./Iconnet + TV.png": "a87f",
	"./Iforte.png": "9247",
	"./Indocyber Net.png": "dddc",
	"./Indosat.png": "7542",
	"./Jedi Solutions.png": "d85f",
	"./LinkNet.png": "89cb",
	"./Lintasarta.png": "6b51",
	"./Moratelindo.png": "c2f4",
	"./My Republic.png": "ff05",
	"./Prime Data.png": "dc3b",
	"./Tachyon Net-old.png": "8188",
	"./Tachyon Net.png": "eadb",
	"./XL Axiata-old.png": "2d80",
	"./XL Axiata.png": "d485d",
	"./XL Home.png": "ee3b",
	"./logo_telkom horizontal.png": "dab7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "93d1";